var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { useDataTableStoreContext, useRecordContext, useStore } from 'ra-core';
import { TableCell, useThemeProps } from '@mui/material';
import { styled } from '@mui/material/styles';
import get from 'lodash/get';
import clsx from 'clsx';
var PREFIX = 'RaDataTableCell';
export var DataTableCell = React.memo(React.forwardRef(function (inProps, ref) {
    var props = useThemeProps({
        props: inProps,
        name: PREFIX,
    });
    var cellSx = props.cellSx, cellClassName = props.cellClassName, headerClassName = props.headerClassName, children = props.children, className = props.className, disableSort = props.disableSort, render = props.render, field = props.field, source = props.source, sortByOrder = props.sortByOrder, label = props.label, sx = props.sx, rest = __rest(props, ["cellSx", "cellClassName", "headerClassName", "children", "className", "disableSort", "render", "field", "source", "sortByOrder", "label", "sx"]);
    var _a = useDataTableStoreContext(), storeKey = _a.storeKey, defaultHiddenColumns = _a.defaultHiddenColumns;
    var hiddenColumns = useStore(storeKey, defaultHiddenColumns)[0];
    var record = useRecordContext();
    var isColumnHidden = hiddenColumns.includes(source);
    if (isColumnHidden)
        return null;
    if (!render && !field && !children && !source) {
        throw new Error('Missing at least one of the following props: render, field, children, or source');
    }
    var sxValue = __assign(__assign({}, (cellSx && record ? cellSx(record) : {})), sx);
    var fieldValue = get(record, source);
    return (React.createElement(TableCellStyled, __assign({ ref: ref, className: clsx(className, cellClassName, "column-".concat(source)), sx: sxValue }, rest), children !== null && children !== void 0 ? children : (render
        ? record && render(record)
        : field
            ? React.createElement(field, { source: source })
            : fieldValue != null
                ? fieldValue.toString()
                : null)));
}));
DataTableCell.displayName = 'DataTableCell';
var TableCellStyled = styled(TableCell, {
    name: PREFIX,
    overridesResolver: function (props, styles) { return styles.root; },
})(function () { return ({}); });
//# sourceMappingURL=DataTableCell.js.map